import React, { useState, useEffect } from 'react';

const QuantityControl = ({
    initialQuantity = 1,
    onIncrease,
    onDecrease
}) => {

    const [quantity, setQuantity] = useState(initialQuantity);

    // update when parent changes quantity
    useEffect(() => {
        setQuantity(initialQuantity);
    }, [initialQuantity]);

    const incrementQuantity = () => {

        const newQty = quantity + 1;

        setQuantity(newQty);

        // call parent function (API)
        if (onIncrease) {
            onIncrease(newQty);
        }
    };

    const decrementQuantity = () => {

        if (quantity <= 1) return;

        const newQty = quantity - 1;

        setQuantity(newQty);

        // call parent function (API)
        if (onDecrease) {
            onDecrease(newQty);
        }
    };

    return (
        <div className="d-flex rounded-4 overflow-hidden">

            {/* MINUS BUTTON */}
            <button
                type="button"
                onClick={decrementQuantity}
                className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
            >
                <i className="ph ph-minus" />
            </button>

            {/* INPUT */}
            <input
                type="number"
                className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-4"
                value={quantity}
                min={1}
                readOnly
            />

            {/* PLUS BUTTON */}
            <button
                type="button"
                onClick={incrementQuantity}
                className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
            >
                <i className="ph ph-plus" />
            </button>

        </div>
    );
};

export default QuantityControl;
